export default "__VITE_ASSET__CoDf7p3p__"